"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEW_COURSE_PURCHASE = exports.STATUS_COURSES = void 0;
var STATUS_COURSES;
(function (STATUS_COURSES) {
    STATUS_COURSES[STATUS_COURSES["COMPLETED"] = 0] = "COMPLETED";
    STATUS_COURSES[STATUS_COURSES["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    STATUS_COURSES[STATUS_COURSES["PENDING"] = 2] = "PENDING";
})(STATUS_COURSES = exports.STATUS_COURSES || (exports.STATUS_COURSES = {}));
var NEW_COURSE_PURCHASE;
(function (NEW_COURSE_PURCHASE) {
    NEW_COURSE_PURCHASE[NEW_COURSE_PURCHASE["TRUE"] = 1] = "TRUE";
    NEW_COURSE_PURCHASE[NEW_COURSE_PURCHASE["FALSE"] = 0] = "FALSE";
})(NEW_COURSE_PURCHASE = exports.NEW_COURSE_PURCHASE || (exports.NEW_COURSE_PURCHASE = {}));
